export const STUDIO_PRESETS = [
  {
    id: 'instagram-post',
    title: 'Instagram Post',
    label: 'Instagram Post',
    width: 1080,
    height: 1080,
    unit: 'px',
    category: 'Instagram',
    tags: ['instagram', 'post', 'square'],
  },
  {
    id: 'instagram-portrait',
    title: 'Instagram Portrait',
    label: 'Instagram Portrait',
    width: 1080,
    height: 1350,
    unit: 'px',
    category: 'Instagram',
    tags: ['instagram', 'portrait', 'vertical'],
  },
  {
    id: 'instagram-story',
    title: 'Instagram Story',
    label: 'Instagram Story',
    width: 1080,
    height: 1920,
    unit: 'px',
    category: 'Instagram',
    tags: ['instagram', 'story', 'vertical'],
  },
  {
    id: 'instagram-reel-cover',
    title: 'Instagram Reel Cover',
    label: 'Instagram Reel Cover',
    width: 1080,
    height: 1920,
    unit: 'px',
    category: 'Instagram',
    tags: ['instagram', 'reel', 'cover', 'vertical'],
  },
  {
    id: 'instagram-carousel',
    title: 'Instagram Carousel',
    label: 'Instagram Carousel',
    width: 1080,
    height: 1080,
    unit: 'px',
    category: 'Instagram',
    tags: ['instagram', 'carousel', 'square'],
  },
  {
    id: 'instagram-profile-pic',
    title: 'Instagram Profile Pic',
    label: 'Instagram Profile Pic',
    width: 320,
    height: 320,
    unit: 'px',
    category: 'Instagram',
    tags: ['instagram', 'profile', 'dp'],
  },
  {
    id: 'whatsapp-status',
    title: 'WhatsApp Status',
    label: 'WhatsApp Status',
    width: 1080,
    height: 1920,
    unit: 'px',
    category: 'WhatsApp',
    tags: ['whatsapp', 'status', 'vertical'],
  },
  {
    id: 'whatsapp-post',
    title: 'WhatsApp Post',
    label: 'WhatsApp Post',
    width: 1080,
    height: 1080,
    unit: 'px',
    category: 'WhatsApp',
    tags: ['whatsapp', 'post', 'square'],
  },
  {
    id: 'whatsapp-dp',
    title: 'WhatsApp DP',
    label: 'WhatsApp DP',
    width: 640,
    height: 640,
    unit: 'px',
    category: 'WhatsApp',
    tags: ['whatsapp', 'dp', 'profile'],
  },
  {
    id: 'facebook-post',
    title: 'Facebook Post',
    label: 'Facebook Post',
    width: 1200,
    height: 630,
    unit: 'px',
    category: 'Facebook',
    tags: ['facebook', 'post', 'landscape'],
  },
  {
    id: 'facebook-story',
    title: 'Facebook Story',
    label: 'Facebook Story',
    width: 1080,
    height: 1920,
    unit: 'px',
    category: 'Facebook',
    tags: ['facebook', 'story', 'vertical'],
  },
  {
    id: 'facebook-cover',
    title: 'Facebook Cover',
    label: 'Facebook Cover',
    width: 820,
    height: 312,
    unit: 'px',
    category: 'Facebook',
    tags: ['facebook', 'cover', 'banner'],
  },
  {
    id: 'youtube-thumbnail',
    title: 'YouTube Thumbnail',
    label: 'YouTube Thumbnail',
    width: 1280,
    height: 720,
    unit: 'px',
    category: 'YouTube',
    tags: ['youtube', 'thumbnail', 'landscape'],
  },
  {
    id: 'youtube-channel-banner',
    title: 'YouTube Channel Banner',
    label: 'YouTube Channel Banner',
    width: 2560,
    height: 1440,
    unit: 'px',
    category: 'YouTube',
    tags: ['youtube', 'banner', 'channel'],
  },
  {
    id: 'youtube-shorts',
    title: 'YouTube Shorts',
    label: 'YouTube Shorts',
    width: 1080,
    height: 1920,
    unit: 'px',
    category: 'YouTube',
    tags: ['youtube', 'shorts', 'vertical'],
  },
  {
    id: 'linkedin-post',
    title: 'LinkedIn Post',
    label: 'LinkedIn Post',
    width: 1200,
    height: 1200,
    unit: 'px',
    category: 'LinkedIn',
    tags: ['linkedin', 'post', 'square'],
  },
  {
    id: 'linkedin-banner',
    title: 'LinkedIn Banner',
    label: 'LinkedIn Banner',
    width: 1584,
    height: 396,
    unit: 'px',
    category: 'LinkedIn',
    tags: ['linkedin', 'banner', 'cover'],
  },
  {
    id: 'x-post',
    title: 'X Post',
    label: 'X Post',
    width: 1600,
    height: 900,
    unit: 'px',
    category: 'X',
    tags: ['x', 'twitter', 'post', 'landscape'],
  },
  {
    id: 'x-header',
    title: 'X Header',
    label: 'X Header',
    width: 1500,
    height: 500,
    unit: 'px',
    category: 'X',
    tags: ['x', 'twitter', 'header', 'banner'],
  },
  {
    id: 'a4-flyer',
    title: 'A4 Flyer',
    label: 'A4 Flyer',
    width: 2480,
    height: 3508,
    unit: 'px',
    category: 'Print',
    tags: ['a4', 'print', 'flyer'],
    isPrint: true,
  },
  {
    id: 'a5-flyer',
    title: 'A5 Flyer',
    label: 'A5 Flyer',
    width: 1748,
    height: 2480,
    unit: 'px',
    category: 'Print',
    tags: ['a5', 'print', 'flyer'],
    isPrint: true,
  },
  {
    id: 'letterhead',
    title: 'Letterhead',
    label: 'Letterhead',
    width: 2550,
    height: 3300,
    unit: 'px',
    category: 'Print',
    tags: ['letterhead', 'print', 'document'],
    isPrint: true,
  },
  {
    id: 'business-card',
    title: 'Business Card',
    label: 'Business Card',
    width: 1050,
    height: 600,
    unit: 'px',
    category: 'Print',
    tags: ['business', 'card', 'print'],
    isPrint: true,
  },
  {
    id: 'poster-a3',
    title: 'Poster A3',
    label: 'Poster A3',
    width: 3508,
    height: 4961,
    unit: 'px',
    category: 'Print',
    tags: ['poster', 'a3', 'print'],
    isPrint: true,
  },
  {
    id: 'property-flyer',
    title: 'Property Flyer',
    label: 'Property Flyer',
    width: 2480,
    height: 3508,
    unit: 'px',
    category: 'Real Estate',
    tags: ['real-estate', 'property', 'flyer', 'print'],
    isPrint: true,
  },
  {
    id: 'open-house-poster',
    title: 'Open House Poster',
    label: 'Open House Poster',
    width: 1080,
    height: 1350,
    unit: 'px',
    category: 'Real Estate',
    tags: ['real-estate', 'open-house', 'poster'],
  },
  {
    id: 'qr-standee',
    title: 'QR Standee',
    label: 'QR Standee',
    width: 1240,
    height: 2688,
    unit: 'px',
    category: 'Real Estate',
    tags: ['real-estate', 'qr', 'standee'],
  },
];

export const DEFAULT_PRESET_ID = 'instagram-post';
